import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule, IonicRouteStrategy, IonNav, NavParams } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MyApp } from './app.component';

import { TabsPage } from '../pages/tabs/tabs';
import { HomePage } from '../pages/home/home';
import { BrowsePage } from '../pages/browse/browse';
import { SearchPage } from '../pages/search/search';
import { LibraryPage } from '../pages/library/library';
import { LoginPage } from '../pages/login/login';
import { PlaylistPage } from '../pages/playlist/playlist';
import { MusicPlayerPage } from '../pages/music-player/music-player';
import { ArtistPage } from '../pages/artist/artist';
import { AlbumPage } from '../pages/album/album';
import { FavoritesPage } from '../pages/favorites/favorites';
import { SettingsPage } from '../pages/settings/settings';
import { ProfilePage } from '../pages/profile/profile';
import { GenrePage } from '../pages/genre/genre';
import { LoginDetailsPage } from '../pages/login-details/login-details';
import { TermsPrivacyPage } from '../pages/terms-privacy/terms-privacy';
// import { StatusBar } from "@ionic-native/status-bar";
// import { SplashScreen } from "@ionic-native/splash-screen";

import firebase from 'firebase';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { AuthService } from '../services/AuthService';
import { FirestoreService } from '../services/FirestoreService';
import { AudioService } from '../services/AudioService';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// import { Stripe } from '@ionic-native/stripe';

// import { Facebook } from "@ionic-native/facebook";
// import { GooglePlus } from "@ionic-native/google-plus";
// import { TwitterConnect } from "@ionic-native/twitter-connect";
import {
  IonicAudioModule,
  defaultAudioProviderFactory,
} from '../components/ionic-audio';
import { ComponentsFooterPlayerComponent } from '../components/components-footer-player/components-footer-player';
import { MusicControls } from '@ionic-native/music-controls/ngx';
// import { BackgroundMode } from "@ionic-native/background-mode";
import { ModelService } from '../services/modalService';
import { ChangeNamePage } from '../pages/change-name/change-name';
import { SongPlayingService } from '../services/songPlayingService';
import { RouteReuseStrategy } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';

import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Howl, Howler } from 'howler';



// Initialize Firebase
var firebaseConfig = {
  // apiKey: "AIzaSyCUjxbDslfmSeNCwDcClzXR1d1hIzQLw50",
  // authDomain: "ionspotify-f5c12.firebaseapp.com",
  // databaseURL: "https://ionspotify-f5c12.firebaseio.com",
  // projectId: "ionspotify-f5c12",
  // storageBucket: "ionspotify-f5c12.appspot.com",
  // messagingSenderId: "395983984847"
  apiKey: 'AIzaSyCuY7JFQN1U5uwM-fGklB-WD0FG3avAD_w',
  authDomain: 'neura-9b648.firebaseapp.com',
  projectId: 'neura-9b648',
  storageBucket: 'neura-9b648.appspot.com',
  messagingSenderId: '859510816624',
  appId: '1:859510816624:web:bb8c43ce50cce6e95e19b5',
};

firebase.initializeApp(firebaseConfig);

@NgModule({
  declarations: [MyApp],
  // entryComponents: [],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    BrowserAnimationsModule,
    IonicAudioModule.forRoot(defaultAudioProviderFactory),
  ],
  providers: [
    AuthService,
    FirestoreService,
    AudioService,
    ModelService,
    IonNav,
    NavParams,
    SongPlayingService,
    StatusBar,
    SplashScreen,
    //     // Stripe,
    //     // GooglePlus,
    //     // TwitterConnect,
    //     // MusicControls,
    //     SongPlayingService,

    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [MyApp],
})
// @NgModule({
//   declarations: [
//     MyApp,
//     HomePage,
//     BrowsePage,
//     SearchPage,
//     LibraryPage,
//     TabsPage,
//     LoginPage,
//     PlaylistPage,
//     MusicPlayerPage,
//     ArtistPage,
//     AlbumPage,
//     FavoritesPage,
//     SettingsPage,
//     ProfilePage,
//     GenrePage,
//     ChangeNamePage,
//     TermsPrivacyPage,
//     LoginDetailsPage,
//     ComponentsFooterPlayerComponent
//   ],
//   imports: [
//     BrowserModule,
//     IonicModule.forRoot(),
//     AngularFireModule.initializeApp(firebaseConfig),
//     AngularFireAuthModule,
//     BrowserAnimationsModule,
//     IonicAudioModule.forRoot(defaultAudioProviderFactory)
//   ],
//   bootstrap: [MyApp],
//   entryComponents: [
//     MyApp,
//     HomePage,
//     BrowsePage,
//     SearchPage,
//     LibraryPage,
//     TabsPage,
//     LoginPage,
//     ChangeNamePage,
//     PlaylistPage,
//     MusicPlayerPage,
//     ArtistPage,
//     AlbumPage,
//     FavoritesPage,
//     SettingsPage,
//     ProfilePage,
//     TermsPrivacyPage,
//     GenrePage,
//     LoginDetailsPage
//   ],
//   providers: [
//     // StatusBar,
//     // SplashScreen,
//     AuthService,
//     FirestoreService,
//     AudioService,
//     // Facebook,
//     ModelService,
//     // Stripe,
//     // GooglePlus,
//     // TwitterConnect,
//     // MusicControls,
//     SongPlayingService,
//     // BackgroundMode,
//     { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
//   ]
// })
export class AppModule { }
